export default __webpack_public_path__ + "static/media/19.e3394ee8.png";